import React, { useEffect } from 'react';
import classnames from 'classnames';

let viewerNotificationTimer = null;

const Notification = (props) => {
    const closeNotification = () => {
        viewerNotificationTimer = null;
        if (viewerNotificationTimer) clearTimeout(viewerNotificationTimer);
        const { onDismiss, duration } = props;
        viewerNotificationTimer = setTimeout(() => {
            if (onDismiss) {
                onDismiss();
            }
        }, duration || 3000);
    };

    useEffect(() => {
        closeNotification();
        return () => {
            if (viewerNotificationTimer) clearTimeout(viewerNotificationTimer);
        };
    });

    const { children, type } = props;
    const subProps = {
        onClick: closeNotification,
        className: classnames('seismic-engagement-viewer-notification', {
            [`--${type}`]: !!type
        })
    };
    return (
        <div {...subProps} >{children}</div>
    );
};

export default Notification;
